import React from 'react'
import AccountLayout from '../../components/AccountLayout'
import { SEO } from '../../components/Seo/seo'
import { useIntl } from 'react-intl'
import { NamedRoutes } from '../../routes'
import LateSubmissionPageContent from '../../components/LateSubmissionPageContent'
import { ListingProvider } from '../../context/ListingContext'
import { LanguageConsumer } from '../../context/LanguageContext'

const LateSubmission = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Page.lateSubmission.title' })}
           pathname={window.location.origin + NamedRoutes.lateSubmission}
           titleTemplate={intl.formatMessage({ id: 'eInvoice' })}
           description={intl.formatMessage({ id: 'Page.lateSubmission.title' })}
      />
      <AccountLayout content={
        <LanguageConsumer>
          {({ locale }) => (
            <ListingProvider entityName={'lateSubmission'} locale={locale}>
              <LateSubmissionPageContent/>
            </ListingProvider>
          )}
        </LanguageConsumer>
      }/>
    </>
  )
}

export default LateSubmission